module.exports = __webpack_public_path__ + "static/media/email.0d8b9dbf.svg";